import React from "react"
import {useTranslation} from "react-i18next"

import {Accordion} from "../../../../components/Accordion.tsx"
import {TextareaBase} from "../../../../components/fields/Textarea.tsx"
import {TFilterProperty} from "../../../../utils/filters.ts"
import {AdvancedLeadsContext} from "../AdvancedSearch/context/context.ts"
import {FilterTitle} from "./utilityComponents/FilterTitle.tsx"
import {useIsFilterDisabled} from "./utilityComponents/useIsFilterDisabled.ts"

const ACME_PLACEHOLDER =
  "ACME is a leading software solutions provider that helps businesses streamline their operations and accelerate growth through innovative technology platforms."

export const TextareaFilter: React.FC<{
  property: TFilterProperty<string>
  placeholder?: string
  rows?: number
  disabled?: boolean
}> = ({property, placeholder, rows = 4, disabled}) => {
  const [value, setValue] = React.useState(property.value)

  React.useEffect(() => {
    setValue(property.valueDebounced)
  }, [property.valueDebounced])

  React.useEffect(() => {
    if (property.value !== "") {
      return
    }
    setValue("")
  }, [property.value])

  const setProperty = property.setValue
  React.useEffect(() => {
    setProperty(value)
  }, [value, setProperty])

  return (
    <TextareaBase
      value={value}
      onChange={e => setValue(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
    />
  )
}

export const CustomElevatorPitch: React.FC = () => {
  const {t} = useTranslation()

  const advancedFiltering = AdvancedLeadsContext.useOptionalContext()
  const customElevatorPitch = advancedFiltering?.customElevatorPitch
  if (!customElevatorPitch) {
    throw new Error("CustomElevatorPitch component can only be used in advanced search context")
  }

  const isDisabled = useIsFilterDisabled()

  return (
    <Accordion
      title={
        <FilterTitle property={customElevatorPitch} disabled={isDisabled}>
          {t("Prospects_ImportModal_LeadsStep_Filter_CustomElevatorPitch", "My Company Profile")}
        </FilterTitle>
      }
      defaultOpen={true}
    >
      <TextareaFilter property={customElevatorPitch} placeholder={ACME_PLACEHOLDER} rows={4} disabled={isDisabled} />
    </Accordion>
  )
}
